import * as React from "react";
const SparePartPackagesView = React.lazy(() => import("./SparePartPackagesViewContainer"));

export { SparePartPackagesView };
